/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 17:58:17
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Layout, Card, FormLayout, Tooltip, Icon, Link } from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FieldArray } from 'redux-form';

import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';
import IgnoreIPsList from './ignore-ips-list';
import { URL } from 'src/constants/links';
import ConfirmToogleOrderRevenueModal from 'src/components/views/analytics/settings/confirm-toogle-order-revenue-modal';
import * as checklistActions from 'actions/dashboard/checklist-actions';

type Props = WithI18nProps;
class Settings extends Component<Props, State> {
  state = {
    activeToggleOrderRevenueModal: false
  };

  render() {
    const { enableOrderRevenue, updatePermissionLink, showOrderRevenue, i18n } = this.props;
    const { activeToggleOrderRevenueModal } = this.state;

    return (
      <div className="BC-Analytics__Settings">
        <Layout>
          {showOrderRevenue && (
            <Layout.Section>
              <Card title={i18n.translate('AdminHTML.Analytics.Common.orderRevenueTracking')}>
                <Card.Section>
                  <div>
                    <FormLayout>
                      <p>
                        {i18n.translate('AdminHTML.Analytics.Settings.settings_FormLayoutChildren')}{' '}
                        <Link external url={URL['OrderRevenueTrackingDoc']}>
                          {i18n.translate('AdminHTML.Analytics.Common.learnMore')}
                        </Link>
                      </p>
                      <div className="BC-Toggle-Switch">
                        <label className="BC-Checkbox-Status">
                          <input
                            type="checkbox"
                            checked={enableOrderRevenue}
                            onChange={this.handleChange}
                          />
                          <span />
                        </label>
                        <div>
                          <RenderLabelTooltip
                            label={i18n.translate(
                              'AdminHTML.Analytics.Settings.settings_RenderLabelTooptipLabel'
                            )}
                          />
                        </div>
                      </div>
                    </FormLayout>
                  </div>
                </Card.Section>
              </Card>
            </Layout.Section>
          )}

          <Layout.Section>
            <Card
              title={
                <div>
                  <span className="Polaris-Heading">
                    {i18n.translate('AdminHTML.Analytics.Settings.settings_CardHeading')}
                  </span>
                  <span className="tooltip">
                    <Tooltip
                      content={
                        <span className="tooltipContent">
                          {i18n.translate('AdminHTML.Analytics.Settings.settings_TooltipContent')}
                        </span>
                      }
                      preferredPosition="above"
                      children={<span>text</span>}>
                      <Icon source={QuestionMarkMajor} color="base" />
                    </Tooltip>
                  </span>
                </div>
              }>
              {/* List of ignore IP*/}

              <FieldArray name="ignoreIPs" component={IgnoreIPsList} />
            </Card>
          </Layout.Section>
        </Layout>
        <ConfirmToogleOrderRevenueModal
          active={activeToggleOrderRevenueModal}
          handleChange={this.handleChange}
          handleApprove={this.handleApprove}
          updatePermissionLink={updatePermissionLink}
          enableOrderRevenue={enableOrderRevenue}
        />
      </div>
    );
  }

  // Handle show hide modal
  handleChange = () => {
    this.setState(({ activeToggleOrderRevenueModal }) => {
      return { activeToggleOrderRevenueModal: !activeToggleOrderRevenueModal };
    });
  };

  handleApprove = async () => {
    const { trackEvent } = this.props;
    await trackEvent('activeCampaign', 'sync_recent_update', 'activeCampaign_sync_recent_update');
  };
}

const mapDispatchToProps = dispatch => ({
  trackEvent: (eventSource, eventName, label) =>
    dispatch(checklistActions.trackEvent(eventSource, eventName, label))
});

const mapStateToProps = (state, props) => {
  const themeSetupV2 = _.get(state.oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false);
  const showRevenueTrackingV1 = _.get(
    state.oauth,
    'tenantApp.adminAppFeatures.showRevenueTrackingV1',
    false
  );

  return {
    // Show/hide order revenue by themeSetupV2 and showRevenueTrackingV1
    showOrderRevenue: themeSetupV2 || showRevenueTrackingV1
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(Settings));
